import React, { useEffect, useRef, useState } from 'react';
import isNull from '../../../../../../../../../../utils/NullChecking';
import SuperSearchList from '../../../../../../../../../shared/SuperSearch/SuperSearchList';

const ProblemArea = (props) => {
  let { objectiveData, setObjectiveData, setSaveFrontBodyDiagramData, setSaveBackBodyDiagramData } = {...props};
  console.log("ProblemArea", )
  const imageRef = useRef(null);
  const maskCanvasRef = useRef(null);

    const  DiagramSideData = [
        { value: "-1", display: "" },
        { value:'FrontBodyDiagram', display:'Front Side'},
        { value:'BackBodyDiagram', display:'Back Side'},
    ]
    const [is, setIs] = useState(true);
    const Search_Name_Data = {
        "DiagramSideName": "Front Side",
    }
    const [searchParamName, setSearchParamName] = useState(Search_Name_Data)
    const Search_Data = {
        "DiagramSide": 'FrontBodyDiagram',
    }
    const [searchParam, setSearchParam] = useState(Search_Data)
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [cursorStyle, setCursorStyle] = useState('default');

    // Load mask into canvas for pixel detection
    useEffect(() => {
        if (!searchParam?.DiagramSide) return;
        const img = new Image();
        img.src = process.env.PUBLIC_URL + 
        (searchParam.DiagramSide === 'FrontBodyDiagram'
            ? "/assets/images/body-front-mask.png"
            : "/assets/images/body-back-mask.png"
        );
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            maskCanvasRef.current = canvas;
        };
    }, [searchParam?.DiagramSide]);

    
    const getNextMarkerId = () => {
        const allMarkers = [
            ...(objectiveData?.FrontBodyDiagram || []),
            ...(objectiveData?.BackBodyDiagram || [])
        ];

        if (allMarkers.length === 0) return "1";

        const maxId = Math.max(...allMarkers.map(m => Number(m.markerId)));
        return (maxId + 1).toString();
    };

    const isClickablePixel = (x, y) => {
        const canvas = maskCanvasRef.current;
        if (!canvas) return false;
        const ctx = canvas.getContext('2d');
        const [r, g, b, a] = ctx.getImageData(x, y, 1, 1).data;
        return r > 200 && g > 200 && b > 200 && a > 20; // white area = clickable
    };

    const handleMouseMove = (e) => {
        if (!maskCanvasRef.current) return;
        const rect = imageRef.current.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * imageRef.current.naturalWidth;
        const y = ((e.clientY - rect.top) / rect.height) * imageRef.current.naturalHeight;
        setCursorStyle(isClickablePixel(x, y)
        ? `url(${process.env.PUBLIC_URL}/assets/images/BodyCursor.svg) 7 7, auto`
        : 'default'
        );
    };

    const handleImageClick = (e) => {
        if (!maskCanvasRef.current) return;
        const rect = imageRef.current.getBoundingClientRect();

        const clickX = e.clientX - rect.left;
        const clickY = e.clientY - rect.top;

        const imgX = (clickX / rect.width) * imageRef.current.naturalWidth;
        const imgY = (clickY / rect.height) * imageRef.current.naturalHeight;

        if (!isClickablePixel(imgX, imgY)) return;

        const markerId = getNextMarkerId();
        const x = (clickX / rect.width) * 100;
        const y = (clickY / rect.height) * 100;

        setSelectedMarker({
            side: searchParam?.DiagramSide,
            markerId,
            x: x.toString(),
            y: y.toString(),
            comment: "",
            isNew: true
        });
    };
    
    // Handle dropdown change
    const handleChangeDD = (e, name) => {
        if (name === 'DiagramSide') {
            setIs(false);
            setSearchParamName(prev => ({ ...prev, DiagramSideName: e.target.value }));
        }
    };

    // Handle selection from SuperSearch
    const handleSelectedData = (selectedData, name, type) => {
        setIs(true);
        if (!isNull(selectedData)) {
            if (type === "client") {
                if (name === "DiagramSide" && !isNull(selectedData)) {
                    setSearchParamName(prev => ({ ...prev, DiagramSideName: selectedData.display }));
                    setSearchParam({ ...searchParam, DiagramSide: selectedData.value });
                }
            }
        } else {
            if (name === "DiagramSide") {
                setSearchParamName(prev => ({ ...prev, DiagramSideName: '' }));
                setSearchParam({ ...searchParam, DiagramSide: '' });
            }
        }
        return selectedData;
    };

    // Handle typing in comment
    const handleChangeComment = (e) => {
        const value = e.target.value;
        setSelectedMarker(prev => ({ ...prev, comment: value }));
    };

    // Save temporary marker as real marker
    const handleAddComment = (e) => {
        e.stopPropagation();
        if (!selectedMarker) return;

        const { side, markerId, x, y, comment } = selectedMarker;

        console.log("selectedMarker123456", selectedMarker)
        // Add marker to objectiveData
        setObjectiveData(prev => ({
            ...prev,
            [side]: [...(prev?.[side] || []), { markerId, x, y, comment }]
        }));

        // Add marker to save data
        const newMarker = { markerId: markerId.toString(), x: x.toString(), y: y.toString(), comment: comment.toString() };
        if (side === 'FrontBodyDiagram') setSaveFrontBodyDiagramData(prev => [...(prev || []), newMarker]);
        if (side === 'BackBodyDiagram') setSaveBackBodyDiagramData(prev => [...(prev || []), newMarker]);

        setSelectedMarker(null);
    };

    // Edit existing marker
    const handleEditMarker = (e, marker) => {
        e.stopPropagation();
        if(marker?.markerId == selectedMarker?.markerId) return;
        setSelectedMarker({
            // side: searchParam?.DiagramSide,
            // markerId: marker.markerId,
            // x: marker.x,
            // y: marker.y,
            // comment: marker.comment,
            ...marker,
            side: searchParam?.DiagramSide,
            isNew: false
        });
    };
    
        console.log("markermarkermarker", selectedMarker)
    const handleRemoveComment = (marker) => {
        // const markerId = mark?.markerId;
        const { TableName, ...mark } = marker;
        const markerId = mark?.markerId;
        setObjectiveData(prev => {

            const isFront = (prev?.FrontBodyDiagram || []).some(item => item.markerId === markerId);
            const isBack = (prev?.BackBodyDiagram || []).some(item => item.markerId === markerId);

            const updatedFront = (prev?.FrontBodyDiagram || []).filter(item => item.markerId !== markerId);
            const updatedBack = (prev?.BackBodyDiagram || []).filter(item => item.markerId !== markerId);

            const updateSaveArray = (prevSave) => {
                // Case 1: marker already saved in DB
                if (mark?.FrontBodyDiagramID || mark?.BackBodyDiagramID) {
                    return [
                        ...(prevSave || []).filter(item => item.markerId !== markerId),
                        { ...mark, Deleted: "true" }
                    ];
                }

                // Case 2: new marker → remove from save
                return (prevSave || []).filter(item => item.markerId !== markerId);
            };

            if (isFront) {
                setSaveFrontBodyDiagramData(prevSave => updateSaveArray(prevSave));
            }

            if (isBack) {
                setSaveBackBodyDiagramData(prevSave => updateSaveArray(prevSave));
            }

            return {
                ...prev,
                FrontBodyDiagram: updatedFront,
                BackBodyDiagram: updatedBack
            };
        });
    };
    const allMarkersSorted = [...(objectiveData?.FrontBodyDiagram || []), ...(objectiveData?.BackBodyDiagram || [])]
        .sort((a, b) => Number(a.markerId) - Number(b.markerId));

    const handleUpdate = (e) => {
        e.stopPropagation();

        const { side, isNew, TableName, ...saveMarker } = selectedMarker;
        // Update UI state
        setObjectiveData(prev => ({
            ...prev,
            [side]: (prev?.[side] || []).map(item =>
                item.markerId === saveMarker?.markerId
                    ? { ...item, comment: saveMarker?.comment }
                    : item
            )
        }));

        const updateSaveArray = (prev) => {
            const exists = (prev || []).some(item => item.markerId === saveMarker?.markerId);

            // Case 1: already in save array
            if (exists) {
                return prev.map(item =>
                    item.markerId === saveMarker?.markerId
                        ? { ...item, comment: saveMarker?.comment }
                        : item
                );
            }

            // Case 2: came from DB → add to save array
            return [
                ...(prev || []),
                {
                    ...saveMarker
                }
            ];
        };

        if (side === "FrontBodyDiagram") {
            setSaveFrontBodyDiagramData(prev => updateSaveArray(prev));
        }

        if (side === "BackBodyDiagram") {
            setSaveBackBodyDiagramData(prev => updateSaveArray(prev));
        }

        setSelectedMarker(null);
    }
    return (
        <div className='ar_body-Comment-design'>
            <div className="d-flex align-items-center justify-content-between select-bg-img-1">
                <p className='heading fs-13'>Problem Area</p>
                <div className="input">
                    <SuperSearchList
                        type="client"
                        id='DiagramSide'
                        name='DiagramSide'
                        searchValue={searchParamName.DiagramSideName}
                        data={DiagramSideData}
                        onChange={(e) => handleChangeDD(e, 'DiagramSide')}
                        getSelectedData={handleSelectedData}
                        is={is}
                        icon={'Simple'}
                        sup_btn='sup_btn'
                        sup_inp='superSearchVisitInp'
                    />
                </div>
            </div>

            {!isNull(searchParam?.DiagramSide) &&
                <div style={{ position: "relative" }}>
                {/* Visible image (markers on top) */}
                <img
                    ref={imageRef}
                    src={process.env.PUBLIC_URL + (searchParam.DiagramSide === 'FrontBodyDiagram'
                        ? "/assets/images/body-front.png"
                        : "/assets/images/body-back.png")}
                    alt="body"
                    style={{
                        width: "100%",
                        display: "block",
                        cursor: cursorStyle
                    }}
                    onClick={handleImageClick}
                    onMouseMove={handleMouseMove}
                    onMouseLeave={() => setCursorStyle('default')}
                />
                    {/* Temporary marker (new) */}
                    {selectedMarker?.isNew && 
                    // selectedMarker?.side === searchParam?.DiagramSide && 
                    (
                        <div
                            style={{
                                position: "absolute",
                                left: `${selectedMarker.x}%`,
                                top: `${selectedMarker.y}%`,
                                transform: "translate(-50%, -50%)",
                                zIndex: 10
                            }}
                            className='ar-marker d-flex align-items-center justify-content-center'
                        >
                            <p className='mark-number font-m text-white text lh-12 d-flex align-items-center justify-content-center'></p>
                            <PopupUseRef onClose={() => setSelectedMarker(null)} IsActivePopup={selectedMarker !== null}>
                            <div
                                className='input-text-wraper d-flex justify-content-between align-items-center gap-20'
                                style={{
                                    position: "absolute",
                                    right: selectedMarker.x < 30 ? "auto" : "30px",
                                    left: selectedMarker.x < 30 ? "30px" : "auto",
                                    top: "50%",
                                    transform: "translateY(-50%)"
                                }}
                            >
                                <input
                                    className='form-control border-0'
                                    placeholder='Add comment'
                                    value={selectedMarker.comment}
                                    onChange={handleChangeComment}
                                />
                                <button
                                    className='btn btn-validate'
                                    disabled={selectedMarker?.comment?.length <= 0}
                                    onClick={handleAddComment}
                                >
                                    <i className='icon-send-svgrepo-com '></i>
                                </button>
                            </div>
                            </PopupUseRef>
                        </div>
                    )}

                    {/* Existing markers */}
                    {(objectiveData?.[searchParam?.DiagramSide] || []).map(marker => (
                        <div
                            key={`${searchParam?.DiagramSide}-${marker.markerId}`}
                            style={{
                                position: "absolute",
                                left: `${marker.x}%`,
                                top: `${marker.y}%`,
                                transform: "translate(-50%, -50%)",
                            }}
                            className='ar-marker d-flex align-items-center justify-content-center'
                            onClick={e => handleEditMarker(e, marker)}
                        >
                            <p className='mark-number font-m text-white text lh-12 d-flex align-items-center justify-content-center'>{marker?.markerId}</p>
                            <PopupUseRef onClose={() => setSelectedMarker(null)} IsActivePopup={selectedMarker !== null}>
                            {
                            // selectedMarker?.side === searchParam?.DiagramSide &&
                             selectedMarker?.markerId === marker.markerId && !selectedMarker?.isNew && (
                                <div
                                    style={{
                                        position: "absolute",
                                        right: marker.x < 40 ? "auto" : "30px",
                                        left: marker.x < 40 ? "30px" : "auto",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                    }}
                                    className='input-text-wraper d-flex justify-content-between align-items-center gap-20'
                                >
                                    <input
                                        className='form-control border-0'
                                        placeholder='Edit comment'
                                        value={selectedMarker.comment}
                                        onChange={handleChangeComment}
                                    />
                                    <button
                                        className='btn btn-validate'
                                        disabled={selectedMarker?.comment?.length <= 0}
                                        onClick={handleUpdate}
                                    >
                                        <i className='icon-send-svgrepo-com '></i>
                                    </button>
                                </div>
                            )}
                            </PopupUseRef>
                        </div>
                    ))}
                </div>
            }

            <div>
                {allMarkersSorted?.length > 0 && (
                <>
                    <p className="heading fs-13 text-decoration-underline">Problem Notes</p>
                    <div className="problem-note-content d-flex flex-column gap-2">
                        {allMarkersSorted.map(mark => (
                            <div key={`note-${mark.markerId}`} className='d-flex justify-content-between align-items-center'>
                                <div className="d-flex align-items-center gap-1">
                                    <p className="ar-mark d-flex align-items-center justify-content-center heading text-white fs-10">{mark?.markerId}</p>
                                    <p className="text">{mark?.comment}</p>
                                </div>
                                <i className='icon-x-cros ar-light-color fw-900' onClick={() => handleRemoveComment(mark)}></i>
                            </div>
                        ))}
                    </div>
                </>
                )}
            </div>
        </div>
    );
};

export default ProblemArea;

const PopupUseRef = ({ children, onClose, IsActivePopup, type }) => {

  const containerRef = useRef(null);

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      onClose()
    }
  };
  useEffect(() => {
    if (IsActivePopup) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [IsActivePopup]);

  return (
    IsActivePopup ? <span ref={containerRef}
      onMouseDown={(e) => e.stopPropagation()} >
      {children}
    </span> : <span className='d-none'>
      {children}
    </span>
  );
};